import React from 'react';
import styled from 'styled-components';
import { buttonCss } from '@ui/atoms';
import { Modal, withModals } from './modal';
import { lifecycle, compose, withState, withHandlers, onlyUpdateForKeys } from 'recompose';
import { selectUserData } from '../selectors';
import { connect } from 'react-redux';
import { getRemainingTime } from '@lib/getRemainingTime';
import { ls } from '@lib/local-storage';
import { formatDate } from '@lib/format-date';
import EndOfSubscription from '@images/svg/end-of-subscription.svg';
import i18next from 'i18next';
import { Colors } from 'planoplan-ui-kit/core/colors';

const mapStateToProps = (state) => ({
  tariff: selectUserData(state).tariff.name,
  expireInDays: getRemainingTime(selectUserData(state).tariff.expire),
  expire: formatDate(selectUserData(state).tariff.expire, 'SHORT'),
  username: selectUserData(state).name,
});

const date = Date.now();
const getLastModalDate = (username) => ls.getItem(username + '.endOfSubscription');

const enchance = compose(
  connect(mapStateToProps),
  onlyUpdateForKeys(['expire']),
  withModals(['endOfSubscription']),
  withState('modalShowDate', 'setModalShowDate', 0),
  lifecycle({
    componentDidMount() {
      const { setModalShowDate, username } = this.props;

      setModalShowDate(getLastModalDate(username));
    },
    componentDidUpdate() {
      const { expireInDays, openModal, modalShowDate, setModalShowDate, username, modals } = this.props;

      if (modals.endOfSubscription.isOpen) return;
      if (modalShowDate !== 0 || getRemainingTime(modalShowDate, true) < 1) return;

      if (expireInDays < 5) {
        openModal('endOfSubscription');
        setModalShowDate(date);
        ls.setItem(username + '.endOfSubscription', date);
      }
    },
  }),
  withHandlers({
    onClose: ({ closeModals, username, setModalShowDate }) => () => {
      setModalShowDate(date);
      ls.setItem(username + '.endOfSubscription', date);
      closeModals();
    },
  })
);

const EndOfSubscriptionModalView = ({ onClose, expire = '', modals, tariff }) => (
  <Modal isOpen={modals.endOfSubscription.isOpen} closeModal={onClose}>
    <Container>
      <Image>
        <Img src={EndOfSubscription} alt={i18next.t('cabinet.tariff.subscription_expires')} />
      </Image>
      <Content>
        <Heading>Заканчивается подписка на тариф</Heading>
        <Text>
          {i18next.t('cabinet.tariff.expires.text', {
            date: expire,
            tariffName: tariff,
          })}
        </Text>
        <Action>
          <Button href="/store" onClick={onClose}>
            Продлить тариф
          </Button>
        </Action>
      </Content>
    </Container>
  </Modal>
);

export const EndOfSubscriptionModal = enchance(EndOfSubscriptionModalView);

const Image = styled.div`
  height: 224px;
  display: flex;
  justify-content: center;
  background-color: ${Colors.azure};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;
const Img = styled.img`
  margin-bottom: 31px;
  margin-top: auto;
`;
const Content = styled.div`
  padding-top: 76px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 44px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
const Heading = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.42;
  letter-spacing: normal;
  margin-bottom: 34px;
`;
const Text = styled.div`
  flex-grow: 1;
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.7;
  letter-spacing: normal;
`;
const Action = styled.div`
  margin-top: auto;
  margin-bottom: 0;
`;
const Container = styled.div`
  width: 560px;
  height: 660px;
  display: flex;
  flex-direction: column;
`;
const Button = styled.a`
  ${buttonCss}
  height: 60px;
  font-size: 18px;
`;
